import { Box, Button, styled, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const StoryContent = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  textOverflow: 'ellipsis',
}));

export const StoryBox = ({ image, bride, groom, story, date }) => {
  const navigate = useNavigate();
    console.log("marriage data", date);
    
  const handleReadMore = (e) => {
    e.stopPropagation();
    navigate('/story-detail', { state: { image, bride, groom, story, date } });
  };

  return (
    <Box
      px={2}
      onClick={handleReadMore}
      sx={{
        cursor: 'pointer',
        maxWidth: { xs: '100%', sm: '360px' },
        margin: 'auto',
      }}
    >
      <div className="storySec">
        <img
          src={image}
          className="img-fluid"
          alt={`${bride} weds ${groom}`}
          style={{
            width: '100%',
            maxWidth: '100%',
            height: '294px',
            borderRadius: '10%',
          }}
        />
        <div className="styoryContent">
          <Typography variant="h5">
            {bride} weds {groom} 
          </Typography>
          <StoryContent variant="body2">
            {story}
          </StoryContent>
          <Button onClick={handleReadMore} size="small">
            Read More
          </Button>
        </div>
      </div>
    </Box>
  );
};
